"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withQueryStringOverrides = void 0;
const overrideUtils_1 = require("./overrideUtils");
const overrideQueryParam = (dvName) => `DV_${dvName}`;
function overriddenGetter(getter, queryParams, transform) {
    return (name, context) => {
        const param = queryParams[overrideQueryParam(name)];
        if (param) {
            const override = transform(param);
            if (override !== null) {
                return override;
            }
        }
        return getter(name, context);
    };
}
exports.withQueryStringOverrides = (interpreter, queryParams) => ({
    featureFlag: (name, on, off, context) => {
        const param = queryParams[overrideQueryParam(name)];
        if (param) {
            const override = overrideUtils_1.OverrideTypes.boolean(param);
            switch (override) {
                case true:
                    return on();
                case false:
                    return off();
                default:
                    break;
            }
        }
        return interpreter.featureFlag(name, on, off, context);
    },
    getBoolean: overriddenGetter(interpreter.getBoolean.bind(interpreter), queryParams, overrideUtils_1.OverrideTypes.boolean),
    getString: overriddenGetter(interpreter.getString.bind(interpreter), queryParams, overrideUtils_1.OverrideTypes.string),
    getFloat: overriddenGetter(interpreter.getFloat.bind(interpreter), queryParams, overrideUtils_1.OverrideTypes.float),
    getInt: overriddenGetter(interpreter.getInt.bind(interpreter), queryParams, overrideUtils_1.OverrideTypes.int),
    /*
     * JSON overrides are complex.
     *
     * If you need to override JSON values for development, we recommend using
     * `withAsyncOverrides` and a static override, instead of using a cookie.
     */
    getJson: interpreter.getJson.bind(interpreter),
});
//# sourceMappingURL=withQueryStringOverrides.js.map